import { z } from "zod";

// Freelancer schema: firstName, lastName, email, country, website (optional), linkedIn
export const freelancerContactInfoFormSchema = z.object({
    firstName: z.string("First Name is required").min(1, 'First name is required'),
    lastName: z.string("Last Name is required").min(1, 'Last name is required'),
    email: z.string("Email is required").min(1, 'Email is required').email('Invalid email address'),
    country: z.string("Country is required").min(1, 'Country is required'),
    website: z.string("Portfolio / Website URL is required").min(1, 'Portfolio / Website URL is required'),
    linkedIn: z.string("LinkedIn URL is required").min(1, 'LinkedIn URL is required'),
})

export const agencyContactInfoFormSchema = z.object({
    agencyName: z.string("Agency Name is required").min(1, 'Agency name is required'),
    website: z.string('Agency Website URL is required').trim().min(1, 'Agency Website URL is required'),
    email: z.string("Email is required").min(1, 'Email is required').email('Invalid email address'),
    country: z.string("Country is required").min(1, 'Country is required'),
    representativeName: z.string("Representative Name is required").min(1, 'Representative name is required'),
    representativeRole: z.string("Representative Role is required").min(1, 'Representative role is required'),
    linkedIn: z.string().optional(),
})

export const appServiceProviderContactInfoFormSchema = agencyContactInfoFormSchema.omit({ website: true });

export type FreelancerContactInfoFormSchema = z.infer<typeof freelancerContactInfoFormSchema>;
export type AgencyContactInfoFormSchema = z.infer<typeof agencyContactInfoFormSchema>;

// Union type for compatibility
export type ContactInfoFormSchema = FreelancerContactInfoFormSchema | AgencyContactInfoFormSchema | z.infer<typeof appServiceProviderContactInfoFormSchema>;
